import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";

const features = [
    {
        title: "Predictive Analytics",
        description: "Leverage data to forecast trends and make informed decisions.",
        imgUrl: "./img/services/machine-learning/predictive-analytics.png",
    },
    {
        title: "Recommendation Systems",
        description: "Provide personalized recommendations to enhance user experience.",
        imgUrl: "./img/services/machine-learning/recomendation-systems.jpg",
    },
    {
        title: "Fraud Detection",
        description: "Identify unusual patterns and detect fraudulent activities.",
        imgUrl: "./img/services/machine-learning/fraud-detection.jpg",
    },
    {
        title: "Customer Segmentation",
        description: "Group customers based on behavior to deliver targeted marketing.",
        imgUrl: "./img/services/machine-learning/customer-segmentation.png",
    },
    {
        title: "Natural Language Processing",
        description: "Understand and generate human-like language responses.",
        imgUrl: "./img/services/machine-learning/nlp.jpg",
    },
    {
        title: "Image and Video Analysis",
        description: "Analyze visual data to automate tasks and extract insights.",
        imgUrl: "./img/services/machine-learning/image-and-video-analytics.jpg",
    },
];


const MachineLearning = () => {
    const [, setScrollY] = useState(0);
    const paths = [
        { name: "Home", link: "/" },
        { name: "Services", link: "" },
        { name: "Machine Learning", link: "" },
    ];

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className="page-overview">
                <PageOverView text="Machine Learning Solutions" description="Transform your business with cutting-edge machine learning models that provide actionable insights and automation." />
            </div>
            <motion.div
                key="div0"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.7 }}>
                <div className="service-page">
                    <div className="uiux-page">
                        <section className="about">
                            <h2>What is Machine Learning?</h2>
                            <p>
                                Machine Learning (ML) enables systems to learn from data and improve their performance without explicit programming. It drives innovation across industries such as healthcare, finance, and retail.
                            </p>
                            <img
                                src="./img/services/machine-learning.jpg"
                                alt="Machine Learning"
                                className="about-image"
                            />
                        </section>
                        <section className="services">
                            <h2>Our Key Services</h2>
                            <div className="services-grid">
                                {features.map((feature, index) => (
                                    <div className="service-card" key={index}>
                                        <img
                                            src={feature.imgUrl}
                                            alt={feature.title}
                                            className="service-img"
                                        />
                                        <h3>{feature.title}</h3>
                                        <p>{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                        <section className="benefits">
                            <h2>Benefits of Machine Learning</h2>
                            <ul>
                                <li>Automate complex tasks, saving time and reducing costs.</li>
                                <li>Enhance decision-making with accurate predictions.</li>
                                <li>Improve customer experiences through personalization.</li>
                                <li>Detect anomalies and mitigate risks proactively.</li>
                                <li>Unlock hidden patterns in data for business insights.</li>
                            </ul>
                        </section>
                        <footer className="contact">
                            <h2>Transform Your Business with Machine Learning</h2>
                            <p>
                                Discover the potential of machine learning for your organization. <br />
                                Contact us at <a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>.
                            </p>
                        </footer>
                    </div>
                </div>
            </motion.div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default MachineLearning;